<template>
  <v-dialog
    :value="show"
    max-width="600"
    @click:outside="$emit('update:show', false)"
  >
    <v-card :loading="loading" :disabled="loading">
      <v-card-title>
        Create Server
      </v-card-title>
      <v-card-text>
        <validation-observer ref="validationObserver" slim>
          <server-form
						v-if="server"
            ref="form"
            v-model="server"
            :params="params"
            @submit="createServer"
          >
          </server-form>
        </validation-observer>
        <v-card-actions>
          <v-btn color="primary" @click="$emit('update:show', false)">
            Back
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="createServer">
            Create
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ServerCreateUpdate from "./ServerCreateUpdate.js";
import { createServer } from "../../../../api/server.api.js";

export default {
  name: "ServerCreateDialog",
  extends: ServerCreateUpdate,
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    show(value) {
      if (value) {
        this.fetchParams();
      } else {
        this.server = {
          domain: "",
          pageStyle: null,
          timeZone: null
        };
      }
    }
  },
  methods: {
    async createServer() {
      const valid = await this.$refs.validationObserver.validate();

      if (valid) {
        const { server } = this;

        createServer(server)
          .then(() => {
            this.$emit("update:show", false);
            this.$emit("create");
          })
          .catch(error =>
            this.handleErrorResponse(this.$refs.validationObserver, error)
          );
      }
    }
  }
};
</script>

<style scoped></style>
